export const PROMO_CODE_NAMESPACE = 'promoCode';
